<template>
    <section class="w-full py-12 md:py-24 lg:py-32 flex justify-center items-center full-height" id="contact">
        <div class="container px-4 md:px-6 lg:px-8 xl:px-10">
            <div class="flex flex-col items-center justify-center space-y-4 text-center">
                <div class="space-y-2">
                    <h2 class="text-3xl font-bold tracking-tighter sm:text-5xl">Join Our Community</h2>
                    <p class="max-w-[600px] text-gray-500 md:text-xl lg:text-base xl:text-xl">
                        Stay updated with our latest features and news.
                    </p>
                    <p class="max-w-[600px] text-gray-500 md:text-xl lg:text-base xl:text-xl">
                        LexelUp is currently in development. Subscribe to our newsletter to be the first to know about
                        the launch.
                    </p>
                </div>
                <div class="w-full max-w-sm space-y-2">
                    <form @submit.prevent="subscribe" class="flex space-x-2" id="email-subscribe-form">
                        <input v-model="email" class="max-w-lg flex-1 border border-black rounded-lg p-2"
                            placeholder="Enter your email" type="email" id="email-input" />
                        <button type="submit"
                            class="inline-flex h-10 items-center justify-center rounded-md bg-gray-900 px-8 text-sm font-medium text-gray-50 shadow transition-colors hover:bg-gray-900/90 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-gray-950 disabled:pointer-events-none disabled:opacity-50">
                            <font-awesome-icon v-if="isLoading" :icon="faSpinner" spin class="mr-2" />
                            Subscribe
                        </button>
                    </form>
                    <p class="text-xs text-gray-500">
                        By subscribing, you agree to our
                        <router-link class="underline underline-offset-2" to="/tos">
                            Terms & Conditions
                        </router-link>.
                    </p>
                    <p v-if="successMessage">{{ successMessage }}</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const email = ref('');
const successMessage = ref('');
const isLoading = ref(false);

const subscribe = async () => {
    isLoading.value = true;
    try {
        const response = await fetch(`${import.meta.env.VITE_API_URL}/newsletter`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ email: email.value }),
        });

        if (!response.ok) {
            successMessage.value = 'An error occurred. Please try again later.';
        }
        successMessage.value = 'Thank you for subscribing!';
        email.value = '';
    } catch (error) {
        console.error('Error:', error);
        successMessage.value = '';
    } finally {
        isLoading.value = false;
    }
};
</script>

<style scoped>
.full-height {
    height: 100vh;
}
</style>